type DataLayerNode = { [k: string]: string | boolean };

declare global {
  interface Window {
    dataLayer: DataLayerNode[];
  }
}

export function pushToDataLayer(data: DataLayerNode) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
}
